const en = {
	translation: {
		'Img magnifier': 'Img magnifier',
		'Search city': 'Search city',
		'Button select language': 'Button select language',
		'Button login': 'Button login',
		'Button profile': 'Button profile',
		'Search button': 'Search button',
		'To come in': 'Login',
		Profile: 'Profile',
		"Button to go to the creator's GitHub":
			"Button to go to the creator's GitHub",
		'Powered by': 'Powered by',
		'Page not found': 'Page not found',
		'Return back': 'Return back',
		'Button return back': 'Button return back',
		Error: 'Error',
		Email: 'Email',
		Password: 'Password',
		'Input email': 'Input email',
		'Input password': 'Input password',
		Login: 'Login',
		"I don't have an account": 'I have an account',
		'Forgot password': 'Forgot password',
		"Button i don't have an account": "Button i don't have an account",
		'Button to come in': 'Button to come in',
		'Button forgot password': 'Button forgot password',
		Register: 'Register',
		'Agree password': 'Agree password',
		'I have an account': 'I have an account',
		'Button i have an account': 'Button i have an account',
		'Button register': 'Button register',
		'Input agree password': 'Input agree password',
		'My profile': 'My profile',
		Exit: 'Exit',
		'Profile image': 'Profile image',
		'Button exit': 'Button exit',
		en: 'en',
		'km/h': 'km/h',
		'Img humindity': 'Img humindity',
		'Img wind': 'Img wind',
		'Img feel like': 'Img feel like',
		'Feel like': 'Feel like',
		Wind: 'Wind',
		'Img visibility': 'Img visibility',
		' Visibility': 'Visibility',
		'Img humidity': 'Img humidity',
		Humidity: 'Humidity',
		'Img pressure': 'Img pressure',
		' Pressure': 'Pressure',
		'Img sea level': 'Img sea level',
		'Sea level': 'Sea level',
	},
};

export default en;
